import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import { TimezoneProvider } from './components/utils/TimezoneContext';
import App from './App';
import axios from 'axios';

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const serverMsg = error && error.response && error.response.data && error.response.data.message;
    if (serverMsg) {
      error.message = serverMsg;
    }
    return Promise.reject(error);
  }
);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <TimezoneProvider>
            <App />
        </TimezoneProvider>
    </Provider>
);